export default {
  units: "kilometers",
  radius: 6371.0088
};